import { useState } from "react";
import { useTranslation, Trans } from "react-i18next";

import Button from "@assessment/components/atoms/button";
import Modal from "@assessment/components/atoms/modal";
import FaqQuestionAndAnswerModal from "../../faq/faqQuetionAndAnsModal";
import Instructions from "../../../instructions";
import DetailsCard from "../../detailsCard";
import StepperForm from "../../stepper-form/stepperForm";

import { useAppSelector } from "@assessment/store/store";

import GL from "../../../../../../assets/GlobalLogic_logo.svg";
import GL_DARK from "../../../../../../assets/GlobalLogic_dark_logo.svg";
import GetHeroIcon from "@assessment/utils/getHeroIcons";
import { InstructionsArr } from "@assessment/utils/instructionsArr";
import "@lxp-app/components/molecules/rich-text-viewer/richTextViewer.css";
import { useSelector } from "react-redux";
import { RootState } from "@lxp-app/store/store";
import hitachiLogo from "@lxp-app/assets/svg/hitachiLogo.svg";
import glLogo from "@lxp-app/assets/png/glLogo.png";
import hitachiDarkLogo from "@lxp-app/assets/svg/hitachiDarkLogo.svg";
import glDarkLogo from "@lxp-app/assets/svg/GlDarkLogo.svg";
import formatCoolOffTime from "../formatCoolOffTime";
import moment from "moment";
import CoolOffPeriodScreen from "../coolOffPeriodScreen";
import { AccessStatus } from "@assessment/types/accessStatus";

const ProgressNotStarted = ({
  isResume = false,
  orgBasedFeatureName = "assessment"
}: {
  isResume?: boolean;
  orgBasedFeatureName?: string;
}) => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.UserInfoSlice.profile);
  const hasAssessmentRecOrgs = user?.hasAssessmentRecOrgs;
  const { isDarkMode } = useSelector(
    (state: RootState) => state?.DarkmodeSlice
  );
  const preAssessmentData = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData
  );
  // const [activeView, setActiveView] = useState<"init" | "stepper">("init");

  const [isFaqModalOpen, setFaqModalOpen] = useState(false);
  let numberOfQuestions: number = 0;

  if (preAssessmentData?.questionTypeCountMap) {
    numberOfQuestions = Object.values(
      preAssessmentData.questionTypeCountMap
    ).reduce((sum: number, value: number) => sum + value, 0);
  }

  const instructionArrValue = InstructionsArr({
    qpInstruction: preAssessmentData.qpInstruction,
    scheduleInstruction: preAssessmentData.scheduleInstruction
  });
  const qpDuration = preAssessmentData?.qpDuration;

  const assessmentAccessResult = useAppSelector(
    (state) => state.AssessmentSlice.accessDetails
  );

  const [activeView, setActiveView] = useState<"init" | "stepper">(
    assessmentAccessResult?.allowedAfter ? "stepper" : "init"
  );

  const isHitachiOrg = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.isHitachiOrg
  );
  const maxAttempts = assessmentAccessResult?.attempts?.maxAttempts || 1;
  const certificateEnabled = preAssessmentData?.certificateConfig?.enableCerti;

  const completedAttempts = assessmentAccessResult?.attempts?.completed || 0;
  const remainingAttempts = maxAttempts - completedAttempts;
  const showCoolOffMessage = completedAttempts === 0 && maxAttempts > 1;
  const allowedAfter = assessmentAccessResult?.allowedAfter;

  const allowedAfterTime = allowedAfter
    ? moment(allowedAfter).fromNow(true)
    : "";
  const coolOffTime = formatCoolOffTime(assessmentAccessResult?.coolofftime, t);

  // const coolOffTime = preAssessmentData?.coolOffTime;
  return (
    <>
      <div className="h-full bg-bkg rounded-[50px] flex flex-col lg:flex-row max-w-[1400px] w-full">
        {activeView === "init" && !isResume && (
          <>
            {/* Left */}
            <div className="w-full lg:w-[45%] px-10 lg:px-20 py-10 flex flex-col h-full overflow-y-auto thin-scrollbar">
              {isHitachiOrg ? (
                <div className="flex items-center h-full">
                  <img
                    onContextMenu={(e) => e.preventDefault()}
                    style={{
                      userSelect: "none",
                      cursor: "pointer"
                    }}
                    className="h-9"
                    src={isDarkMode ? hitachiDarkLogo : hitachiLogo}
                    alt="hitachiLogo"
                  />
                  <div className="w-0.5 bg-[#D40000] h-9 mx-2"></div>
                  <img
                    onContextMenu={(e) => e.preventDefault()}
                    style={{
                      userSelect: "none",
                      cursor: "pointer"
                    }}
                    className="h-7"
                    src={isDarkMode ? glDarkLogo : glLogo}
                    alt="glLogo"
                  />
                </div>
              ) : (
                <img
                  src={isDarkMode ? GL_DARK : GL}
                  alt="GlobalLogic Logo"
                  className="-ml-5 w-72"
                />
              )}

              {/* Name and title */}
              <div className="mt-16 space-y-3">
                <h3 className="text-xl font-medium text-secondary/70">
                  {t("assessment.labels.welcome")},{" "}
                  <span>
                    {user?.name?.firstName ||
                      t("assessment.labels.userFallback")}
                  </span>
                </h3>
                <h1 className="text-3xl font-semibold text-primary">
                  {preAssessmentData?.title}
                </h1>
              </div>
              {/* Meta */}
              <div className="flex flex-wrap items-center justify-between mt-14 gap-y-5 gap-x-10 mb-10">
                <div>
                  <h3 className="text-base font-medium">
                    {t("assessment.labels.totalDuration")}
                  </h3>
                  <p className="text-base text-secondary/70">
                    {qpDuration} {t("assessment.labels.minutes")}
                  </p>
                </div>
                <div>
                  <h3 className="text-base font-medium">
                    {t("assessment.labels.numberOfQuestions")}
                  </h3>
                  <p className="text-base text-secondary/70 text-center">
                    {numberOfQuestions}
                  </p>
                </div>
                <div>
                  <h3 className="text-base font-medium">
                    {t("assessment.labels.numberOfSections")}
                  </h3>
                  <p className="text-base text-secondary/70 text-center">
                    {preAssessmentData?.no_of_sections}
                  </p>
                </div>
              </div>
              {/* <div className="">
                <NumberOfAttemptDetail/>
              </div> */}
              {/* Button */}
              <div className="my-10 pb-14 flex-1 flex flex-col justify-end space-y-8">
                {certificateEnabled ? (
                  <div className="flex px-5 py-3 gap-3 rounded-r-md border-l-4 border-l-primary text-primary bg-primary-light">
                    <GetHeroIcon
                      name="ExclamationCircleIcon"
                      variant="solid"
                      className="w-5 h-5 text-primary"
                    />
                    <span>
                      <>
                        This assessment is eligible for a certificate. Achieve{" "}
                        {preAssessmentData.passPercentage}% or above to earn
                        your certificate.
                      </>
                    </span>
                  </div>
                ) : (
                  <></>
                )}
                <div className="flex px-5 py-3 gap-3 rounded-r-md border-l-4 border-l-primary text-primary bg-primary-light">
                  <GetHeroIcon
                    name="ExclamationCircleIcon"
                    variant="solid"
                    className="w-5 h-5 text-primary"
                  />
                  <span>
                    {maxAttempts === -1 ? (
                      <>
                        <Trans i18nKey="assessment.progress.attemptsUnlimited" />
                        {coolOffTime && (
                          <Trans
                            i18nKey="assessment.progress.coolOffAfterAttempt"
                            values={{ coolOffTime }}
                            components={{
                              strong: (
                                <span className="font-bold text-primary" />
                              )
                            }}
                          />
                        )}
                      </>
                    ) : maxAttempts === 1 ? (
                      <Trans
                        i18nKey="assessment.progress.attemptsSingle"
                        components={{
                          strong: <span className="font-bold text-primary" />
                        }}
                      />
                    ) : (
                      <>
                        <Trans
                          i18nKey="assessment.progress.attemptsMultiple"
                          values={{
                            remainingAttempts,
                            maxAttempts
                          }}
                          components={{
                            strong: <span className="font-bold text-primary" />
                          }}
                        />
                        {coolOffTime && (
                          <Trans
                            i18nKey="assessment.progress.coolOffAfterAttempt"
                            values={{ coolOffTime }}
                            components={{
                              strong: (
                                <span className="font-bold text-primary" />
                              )
                            }}
                          />
                        )}
                      </>
                    )}
                  </span>
                </div>
                <Button
                  buttonColor="primary"
                  variant="contained"
                  className="w-full"
                  onClick={() => {
                    setActiveView("stepper");
                    localStorage.setItem("feedbackSubmitted", "false");
                  }}
                >
                  {t("assessment.progress.proceed")}
                </Button>
              </div>
              {/* Links */}
              <div className="flex justify-start gap-3 mt-4 items-center">
                <span className="text-blue-500 underline underline-offset-1">
                  <a
                    className="text-sm font-medium cursor-pointer"
                    href={
                      hasAssessmentRecOrgs && !isHitachiOrg
                        ? "https://mail.google.com/mail/?view=cm&fs=1&to=amith.c@globallogic.com"
                        : "https://mail.google.com/mail/?view=cm&fs=1&to=support.glx@globallogic.com"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("assessment.labels.platformHelp")}
                  </a>
                </span>
                <div className="w-px h-4 bg-blue-500" />
                <p
                  className="text-sm font-medium text-blue-500 underline cursor-pointer"
                  onClick={() => setFaqModalOpen(true)}
                >
                  {t("assessment.labels.faq")}
                </p>
              </div>
            </div>
            {/* Right */}
            <div className="flex flex-col w-full flex-1 px-4 sm:px-8 md:px-10 lg:px-16 pb-6 pt-10 border-t-2 lg:border-t-0 lg:border-l-2 border-border overflow-y-hidden  thin-scrollbar overflow-x-auto h-[90vh]">
              <Instructions instructionType={instructionArrValue} />
            </div>
          </>
        )}
        {activeView === "stepper" && !isResume && (
          <>
            <DetailsCard />
            {assessmentAccessResult?.accessAllowed && <StepperForm />}
            {assessmentAccessResult?.accessAllowed === false &&
              assessmentAccessResult?.accessStatus ===
                AccessStatus.COOL_OFF_PERIOD_NOT_FINISHED && (
                <div className="flex flex-col w-full flex-1 px-4 sm:px-8 md:px-10 lg:px-16 pb-6 pt-2 lg:pt-6 border-t-2 lg:border-t-0 overflow-y-auto thin-scrollbar">
                  <CoolOffPeriodScreen
                    allowedAfter={assessmentAccessResult.allowedAfter}
                    coolOffTime={formatCoolOffTime(
                      assessmentAccessResult?.coolofftime,
                      t
                    )}
                    orgBasedFeatureName={orgBasedFeatureName}
                  />
                </div>
              )}
          </>
        )}
      </div>
      {isResume && <StepperForm isResume={isResume} />}
      <Modal
        open={isFaqModalOpen}
        dialogueClassName="w-[100%] sm:w-[50%] max-h-[75vh] overflow-y-auto thin-scrollbar sm:p-6"
        // dialogueClassName="sm:max-w-fit sm:mx-10"
        // dialogueClassName= "sm:max-w-3xl p-4"
        childDialogTitle={t("assessment.labels.frequentlyAskedQuestions")}
        closeBtn={true}
        children={<FaqQuestionAndAnswerModal setOpen={setFaqModalOpen} />}
      />
    </>
  );
};

export default ProgressNotStarted;
